// Import hooks
import {
	useInputForm,
	UseInputFormResult,
} from '@app/hooks/view/input';
// Import props
import {
	InputCheckboxProps,
	InputFormProps,
} from '@app/props';
import ValidatorResponse from 'Models/AppModels/ValidatorResponse';

interface UseInputAcknowledgementCheckboxParameters {
	id: string;
	label: string;
	validationLabel?: string;
	required: boolean;
	disabled: boolean;
	isChecked: boolean,
	showValidation?: boolean;
}

type UseInputAcknowledgementCheckboxResults = UseInputFormResult<boolean, InputCheckboxProps>;

const useInputAcknowledgementCheckbox = (params: UseInputAcknowledgementCheckboxParameters): UseInputAcknowledgementCheckboxResults => {
    
    // #region exported methods

	/**
	 * Returns props for form input. 
	 **/
	const applyAcknowledgementCheckboxProps = (): InputCheckboxProps => {
		// First apply the form input props.
		const formProps: InputFormProps = applyProps();
		// Then apply the checkbox props.
		return {
			...formProps,
			isChecked: other.value,
			onChange: other.setInput
		}
	};

	// #endregion exported methods
	
	// #region private methods

	const validateAcknowledgement = (isChecked: boolean, required: boolean): ValidatorResponse => {
		let response: ValidatorResponse = new ValidatorResponse(true, String.empty());

		if (required && !isChecked) {
			response = new ValidatorResponse(false, params.validationLabel ?? 'Please, read and acknowledge this document.');
		}

		return response;
	}

	// #endregion private methods
	

	// #region variables

	const { applyProps, ...other } = useInputForm<boolean>({
		id: params.id,
		label: params.label,
		required: params.required,
		disabled: params.disabled,
		initialInput: params.isChecked,
		showValidation: params.showValidation,
		validators: [validateAcknowledgement],
	});

	// #endregion variables


	return {
		applyProps: applyAcknowledgementCheckboxProps,
		...other,
	};
}

export {
    UseInputAcknowledgementCheckboxParameters,
}

export {
    UseInputAcknowledgementCheckboxResults,
}

export default useInputAcknowledgementCheckbox;